import {
  IAction,
  IApiAction,
  IInputAction,
  IPromiseAction,
  IPropAction,
} from '../../models/ActionModels';
import { IError } from '../../models/StateModels';
import { ActionTypes } from '../ActionTypes';

const action_api_set_input = <T>(
  subtype: string,
  saveInput: boolean,
  input: T | null | undefined
): IInputAction<T> => {
  return {
    type: ActionTypes.ASYNC_SET,
    subtype: subtype,
    payload: {
      saveInput: saveInput,
      input: saveInput ? input : null,
    },
    isInterfaceInputAction: undefined,
  };
};

const action_api_reset_store = <T>(subtype: string, input: T): IInputAction<T> => {
  return {
    type: ActionTypes.RESET_STORE,
    subtype: subtype,
    payload: {
      saveInput: false,
      input: input,
    },
    isInterfaceInputAction: undefined,
  };
};

const action_async_start_promise = <T>(
  subtype: string,
  promise: Promise<any>,
  track: boolean,
  saveInput: boolean,
  input: T | null | undefined
): IPromiseAction<T> => {
  return {
    type: ActionTypes.ASYNC_START,
    subtype: subtype,
    payload: {
      promise: promise,
      saveInput: saveInput,
      input: saveInput ? input : null,
    },
    tracking: track,
    isInterfacePromiseAction: undefined,
  };
};

const action_async_complete_api = <T>(
  subtype: string,
  data: T | null | undefined,
  error: IError | null | undefined
): IApiAction<T> => {
  return {
    type: ActionTypes.ASYNC_COMPLETE,
    subtype: subtype,
    payload: {
      data: data,
      hasError: error !== null && error !== undefined,
      error: error,
    },
    isInterfaceApiAction: undefined,
  };
};

const action_page_loaded = (subtype: string): IAction => {
  return {
    type: ActionTypes.PAGE_LOADED,
    subtype: subtype,
    payload: undefined,
  };
};

const action_page_unloaded = (subtype: string): IAction => {
  return {
    type: ActionTypes.PAGE_UNLOADED,
    subtype: subtype,
    payload: undefined,
  };
};

const action_page_props_sent = <T>(
  subtype: string,
  data: T,
  error: IError | null | undefined
): IPropAction<T> => {
  return {
    type: ActionTypes.PAGE_PROPS_SENT,
    subtype: subtype,
    payload: {
      props: data,
      hasError: error !== null && error !== undefined,
      error: error,
    },
  };
};

export default {
  action_api_reset_store: action_api_reset_store,
  action_api_set_input: action_api_set_input,
  action_async_start_promise: action_async_start_promise,
  action_async_complete_api: action_async_complete_api,
  action_page_props_sent: action_page_props_sent,
  action_page_loaded: action_page_loaded,
  action_page_unloaded: action_page_unloaded,
};
